import React from 'react';
import LoadingAnimation from './LoadingAnimation.react';
import CenteredOverlay from './CenteredOverlay.react';

class LoadingOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false
    };
  }

  componentDidMount() {
    // For some reason, the CSS transition doesn't
    // apply unless we do this asynchronously
    setTimeout(() => {
      this.setState({
        isMounted: true
      });
    });
  }

  render() {
    var style = {};
    if (this.props.posterUrl) {
      style.background = `url(${this.props.posterUrl})`;
      style.backgroundSize = 'cover';
    }

    var classes = 'b-loading-overlay';
    if (this.state.isMounted) {
      classes += ' mounted';
    }
    return (
      <CenteredOverlay className={classes} style={style}>
        <LoadingAnimation />
      </CenteredOverlay>
    );
  }
}

export default LoadingOverlay;
